import { PropsWithChildren } from 'react';
import { Flex, Spinner } from '@sapphire-react/core';
import { useTranslation } from 'react-i18next';
import { useSapphireMedia } from '../hooks';

type Props = {
  isLoading: boolean;
};

export function LoadingOverlay({
  children,
  isLoading,
}: PropsWithChildren<Props>) {
  const { isExtraSmall, isSmall } = useSapphireMedia();
  const { t } = useTranslation();

  return (
    <>
      <Flex
        flexFlow={'row'}
        justifyContent={'center'}
        role={'region'}
        aria-label={'results'}
        width={'100%'}
      >
        {isLoading && (
          <Spinner
            alignSelf={'flex-start'}
            position={'absolute'}
            size={isExtraSmall || isSmall ? 'lg' : 'xl'}
            aria-label={t('loadingSpinnerAriaLabel')}
            marginTop={120}
          />
        )}
      </Flex>
      {children}
    </>
  );
}
